import { useMutation, useQueryClient } from "react-query";

export const useValidateAddressMutation = () => {
    const queryClient = useQueryClient();

    return useMutation('setAddress', (placeObject: any) =>
      queryClient.setQueryData('coverageToolInputAddress', placeObject)
    );
  };
